import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=257f4b64"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257f4b64')) {
      api.createRecord('257f4b64', component.options)
    } else {
      api.reload('257f4b64', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=257f4b64", function () {
      api.rerender('257f4b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/user/Edit.vue"
export default component.exports